module.exports = __webpack_public_path__ + "static/da_graphik-cc16e91170d3422aad8a4f65aa6f295c.png";